module.exports = __webpack_public_path__ + "img/th.87e953c9.svg";